import { useDispatch, useSelector } from 'react-redux'
import { getUserToken } from 'app/utils/browser'
import { talkWithOperatorInsteadOfBot } from 'app/redux/messages/messages.actions'

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts
const getIsConnectWithOperatorEnabled = ({ widgetData }) => widgetData.widgetInfo.data.isConnectWithOperatorEnabled

function AiBotMsgWrapper({
  isAiBotMsg,
  hideConnectWithOperatorBtn,
  conversationId,
  activeDepartment,
  isLastMsg,
  children,
}) {
  const isConnectWithOperatorEnabled = useSelector(getIsConnectWithOperatorEnabled)
  const showConnectWithAgentBtn = isAiBotMsg && isLastMsg && !hideConnectWithOperatorBtn && isConnectWithOperatorEnabled

  const texts = useSelector(getTexts)
  const dispatch = useDispatch()

  const handleClickTalkWithOperatorBtn = () => {
    const data = {
      conversationId,
      userId: getUserToken(),
      botStatus: false,
      teamId: activeDepartment,
    }

    dispatch(talkWithOperatorInsteadOfBot(data))
  }

  const renderConnectWithOperatorBtn = showConnectWithAgentBtn && (
    <button onClick={handleClickTalkWithOperatorBtn} className="talk_with_operator_btn">
      {texts.sendRequestForConnectToAgent}
    </button>
  )

  return (
    <>
      {children}
      {renderConnectWithOperatorBtn}
    </>
  )
}

export default AiBotMsgWrapper
